import get from 'lodash/get'

const requiresBackendFiltering = (stackOptions) => {
    if (!stackOptions) return false
    return get(stackOptions, 'caching__backend') == 'postcache'
}

export default requiresBackendFiltering
